import { useEffect, useRef } from 'react';
import { IHeroProps } from './interfaces';
import { HeroBlock, Inner, Title, Wrapper } from './hero.styles';

export const Hero = ({ title, lottieProps }: IHeroProps): JSX.Element => {
  const ref = useRef<any>(null);

  useEffect(() => {
    import('@lottiefiles/lottie-player');

    return () => {
      ref.current?._lottie?.destroy();
    };
  }, []);

  return (
    <Wrapper>
      <Inner>
        <Title>{title}</Title>
        {lottieProps && (
          <lottie-player
            ref={ref}
            autoplay
            mode="normal"
            class="hero__lottie"
            {...lottieProps}
          />
        )}
      </Inner>
      <HeroBlock />
    </Wrapper>
  );
};
